import { QtyInput } from '../Forms/FormFormatters/QtyInput';
import { UnitPriceInput } from './FormFormatters/UnitPriceInput';
import { DescriptionInput } from './FormFormatters/DescriptionInput';
import { Delete } from './FormFormatters/Delete';
import { WidthFormatter } from './FormFormatters/WidthFormatter';
import NumberFormat from 'react-number-format';
import { currencyInputFormatter } from './FormFormatters/CurrencyInputFormatter';

export const getColumns = ({ validator, validationTick, forceValidationRenderer, validationFired }) => [
    {
        dataField: 'id',
        isDummyField: true,
        hidden: true
    },
    {
        dataField: 'qty',
        text: 'Qty',
        style: WidthFormatter('qty'),
        formatter: (cell, row) => (
            <QtyInput
                field='qty'
                cell={cell}
                row={row}
            />
        )
    },
    {
        dataField: 'description',
        text: 'Product Description (include brand name)',
        formatter: (cell, row) => (
            <DescriptionInput
                field='description'
                cell={cell}
                row={row}
            />
        )
    },
    {
        dataField: 'price',
        text: 'Price Per Unit',
        style: {
            ...WidthFormatter('totalPrice'),
            verticalAlign: 'top'
        },
        formatter: (cell, row) => {
            const hasError = Number(row.price) === 0;
            void validationTick;
            return (
                <UnitPriceInput
                    field='price'
                    cell={cell}
                    row={row}
                    className={hasError ? 'errorMsg' : ''}
                    validator={validator}
                    forceUpdate={forceValidationRenderer}
                    validationFired={validationFired}
                    hasError={hasError}
                />
            );
        }
    },
    {
        dataField: 'total',
        text: 'Total Price',
        style: WidthFormatter('totalPrice'),
        formatter: (cell, row) => {
            const total = parseFloat(row.qty) * parseFloat(row.price);
            const displayValue = isNaN(total) ? '0.00' : total.toFixed(2);
            return (
                <NumberFormat
                    key={[row.id, 'total', 'price'].join('_')}
                    className='form-control'
                    disabled={true}
                    prefix='$'
                    thousandSeparator
                    decimalScale={2}
                    fixedDecimalScale
                    format={currencyInputFormatter}
                    value={displayValue}
                />
            );
        }
    },
    {
        dataField: 'action',
        text: '',
        style: {
            verticalAlign: 'middle'
        },
        formatter: (cell, row, rowIndex) => {
            if (rowIndex <= 0) return;
            return (
                <Delete
                    cell={cell}
                    row={row}
                />
            );
        }
    }
];
